module.exports = __webpack_public_path__ + "66426dc75e870e56854e5320a2298d30.png";